import { useEffect } from "react";
import type { ReactNode } from "react";
import { useLocation } from "wouter";
import { Header } from "./Header";
import { Footer } from "./Footer";

/** Shared chrome for every public marketing page: sticky header + footer. */
export function MarketingLayout({ children }: { children: ReactNode }) {
  const [location] = useLocation();

  // Scroll to top on route change so each page opens at the hero.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location]);

  return (
    <div className="marketing-layout flex min-h-[100dvh] w-full max-w-full flex-col overflow-x-hidden bg-white font-sans text-slate-900 antialiased">
      <Header />
      <main className="flex-1 w-full max-w-full overflow-x-hidden">{children}</main>
      <Footer />
    </div>
  );
}
